import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import type { Planbook } from "@shared/models/planbook"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor"

interface Sig {
  Args: {
    modelsNeededForFirstEdit: ModelsNeededForFirstEdit
    dateString: string
    courseDate: CourseDateCombined
    course: Course
    planbook: Planbook
    goBack: () => void
    closeMenu: () => void
  }
}

export default class ChangeTimeComponent extends Component<Sig> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::LessonMenu::ChangeTime": ChangeTimeComponent
  }
}
